import React from 'react'
import "./footer.css"
import {FaFacebookF} from 'react-icons/fa'
import {FiTwitter} from 'react-icons/fi'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>Harsh</a>

      <ul className="permalinks">
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.facebook.com/harsh.marolia.7/"><FaFacebookF/></a>
        <a href="https://twitter.com/MaroliaHarsh"><FiTwitter/></a>
      </div>

      <div className="footer__copywrite">
        <small>&copy; Harsh. All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer